import types from "../../../../actions/types"

export default function process(state, action) {
  switch (action.type) {
    case types.processingStart: {
      return {
        type: action.processType,
        task: action.task,
      }
    }
    case types.processingComplete:
      if (
        state &&
        state.type === action.processType &&
        state.task === action.task
      ) {
        return null
      }
      return state
    default:
      return state
  }
}
